import { DEVELOPER_ID } from 'shared/constants/developer';

interface ICreateDeveloperProductArguments {
  extra?: Record<string, unknown>;
  id?: number;
  offerType?: string;
}

export interface IDeveloperProduct {
  extra: Record<string, unknown> | undefined;
  id: number;
  offerType: string;
}

export function createDeveloperProduct({
  extra,
  id = DEVELOPER_ID,
  offerType = 'builder',
}: ICreateDeveloperProductArguments = {}): IDeveloperProduct {
  return { extra, id, offerType };
}
